// src/app/shared/services/comment.service.ts

import { Injectable } from '@angular/core';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { URL } from '@app-shared/constants/service-urls';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  constructor(private api: ApiService) {}

  getComments(module: string, id: string, organizationId: string): Observable<any> {
    return this.api.get(`${URL.COMMENT.GET_COMMENTS}/${module}/${id}/${organizationId}`);
  }

  getReactions(commentId: string) {
  return this.api.get(`${URL.COMMENT.GET_REACTIONS}/${commentId}`);
}


  
  addComment(module: string, id: string, organization_id: string, comment_text: string, created_by: string, entityStatus: string): Observable<any> {
  return this.addCommentWithAttachments(module, id, organization_id, comment_text, created_by, entityStatus, []);
}

  addCommentWithAttachments(
    module: string,
    id: string,
    organization_id: string,
    comment_text: string,
    created_by: string,
    entityStatus: string,
    attachment_ids: string[] = [],
    mention_user_ids: Array<string | number> = [],
    app_link: string = ''
  ): Observable<any> {
    const payload = {
    requestBody: {
      id,
      organization_id,
      comment_text,
      created_by,
      status: entityStatus.toLowerCase() || 'active',
      attachment_ids,
      mention_user_ids,
      app_link,
    }
};
    return this.api.post(`${URL.COMMENT.ADD_COMMENT}/${module}`, payload);
}

addReply(parent_comment_id: string, module: string, id: string, organization_id: string, comment_text: string , created_by: string, attachment_ids: string[] = [], mention_user_ids: Array<string | number> = [], app_link: string = ''): Observable<any> {
  const payload = {
    requestBody: {
    parent_comment_id,
    module,
    id,
    organization_id,
    comment_text,
    created_by,
    attachment_ids,
    mention_user_ids,
    app_link,
  }
};
  return this.api.post(`${URL.COMMENT.ADD_REPLY}/${module}`, payload);
}

deleteComment(comment: {
  comment_id: number,
  parent_comment_id: number,
  module: string, 
  id: string,
  organization_id: number
  created_at: number
}): Observable<any> {
  return this.api.put(`${URL.COMMENT.DELETE_COMMENT}`, comment);
}



  addReaction(payload: any) {
    const postData: APIRequest = {
      requestBody: payload,
    };
    return this.api.post(URL.COMMENT.ADD_REACTION, postData);
  }

  uploadAttachment(file: string, originalFileName: string, folder = 'user_attachments', fileType = ''): Observable<any> {
    const postData: APIRequest = {
      requestBody: {
        file,
        folder,
        originalFileName,
        fileType,
      },
    };

    return this.api.post(URL.ADMIN.UPLOAD_FILES, postData);
  }

  getSignedUrls(fileKeys: string[]): Observable<any> {
    const postData: APIRequest = {
      requestBody: {
        fileKeys,
      },
    };

    return this.api.post(URL.ADMIN.signedUrl, postData);
  }

  downloadAttachment(key: string): Observable<any> {
    const postData: APIRequest = {
      requestBody: {
        key,
      },
    };

    return this.api.postBlob(URL.ADMIN.DOWNLOAD_ATTACHMENT, postData);
  }
}
